import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputTextJSX from './InputTextJSX';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import Beatloader from '../../../../Common/Loaders/Beatloader';


const EditCountry = ({ country_id, show, handleClose, token, user_id, refresh, loadingMasterCountryDetail, MasterCountryDetail }) => {

    const [disableSubmit, setDisableSubmit] = useState(false);

    let [showLoader, setShowLoader] = useState(false);

    let initialValues = {
        name: "",
        sort_name: "",
        numeric_code: "",
        iso2: "",
        phone_code: "",
        capital: "",
        currency: "",
        currency_name: "",
        currency_symbol: "",
        native: "",
        region: "",
        subregion: "",
        nationality: "",
        latitude: "",
        longitude: "",
    };


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                if(country_id){
                    values.id = country_id
                }else{
                    toast.error("Country id not found. Please retry or contact admin.");
                    return;
                }
                // console.log(values);
                setDisableSubmit(true);
                axios.post(`${adminMainUrl}/api/master/country/edit`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (loadingMasterCountryDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (MasterCountryDetail) {
            // console.log(MasterCountryDetail);
            formik.setFieldValue("name", MasterCountryDetail?.name);
            formik.setFieldValue("sort_name", MasterCountryDetail?.sort_name);
            formik.setFieldValue("numeric_code", MasterCountryDetail?.numeric_code);
            formik.setFieldValue("iso2", MasterCountryDetail?.iso2);
            formik.setFieldValue("phone_code", MasterCountryDetail?.phone_code);
            formik.setFieldValue("capital", MasterCountryDetail?.capital);
            formik.setFieldValue("currency", MasterCountryDetail?.currency);
            formik.setFieldValue("currency_name", MasterCountryDetail?.currency_name);
            formik.setFieldValue("currency_symbol", MasterCountryDetail?.currency_symbol);
            formik.setFieldValue("native", MasterCountryDetail?.native);
            formik.setFieldValue("region", MasterCountryDetail?.region);
            formik.setFieldValue("subregion", MasterCountryDetail?.subregion);
            formik.setFieldValue("nationality", MasterCountryDetail?.nationality);
            formik.setFieldValue("latitude", MasterCountryDetail?.latitude);
            formik.setFieldValue("longitude", MasterCountryDetail?.longitude);
        }
    }, [loadingMasterCountryDetail, MasterCountryDetail]);

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Country Details</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <InputTextJSX
                                        labelText={"Country Name"}
                                        nameValue={"name"}
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />

                                    <InputTextJSX
                                        labelText={"Short Name"}
                                        nameValue={"sort_name"}
                                        value={formik.values.sort_name}
                                        onChange={formik.handleChange}
                                        maxLength={3}
                                    />

                                    <InputTextJSX
                                        labelText={"Numeric Code"}
                                        nameValue={"numeric_code"}
                                        value={formik.values.numeric_code}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />

                                    <InputTextJSX
                                        labelText={"Phone Code"}
                                        nameValue={"phone_code"}
                                        value={formik.values.phone_code}
                                        onChange={formik.handleChange}
                                        maxLength={5}
                                    />

                                    <InputTextJSX
                                        labelText={"Capital"}
                                        nameValue={"capital"}
                                        value={formik.values.capital}
                                        onChange={formik.handleChange}
                                    />

                                    <InputTextJSX
                                        labelText={"Currency Code"}
                                        nameValue={"currency"}
                                        value={formik.values.currency}
                                        onChange={formik.handleChange}
                                        maxLength={3}
                                    />

                                    <InputTextJSX
                                        labelText={"Currency Name"}
                                        nameValue={"currency_name"}
                                        value={formik.values.currency_name}
                                        onChange={formik.handleChange}
                                    />

                                    <InputTextJSX
                                        labelText={"Currency Symbol"}
                                        nameValue={"currency_symbol"}
                                        value={formik.values.currency_symbol}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />

                                    <InputTextJSX
                                        labelText={"Region"}
                                        nameValue={"region"}
                                        value={formik.values.region}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />

                                    <InputTextJSX
                                        labelText={"Subregion"}
                                        nameValue={"subregion"}
                                        value={formik.values.subregion}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />

                                    <InputTextJSX
                                        labelText={"Nationality"}
                                        nameValue={"nationality"}
                                        value={formik.values.nationality}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />

                                    <InputTextJSX
                                        labelText={"Latitude"}
                                        nameValue={"latitude"}
                                        value={formik.values.latitude}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />

                                    <InputTextJSX
                                        labelText={"Longitude"}
                                        nameValue={"longitude"}
                                        value={formik.values.longitude}
                                        onChange={formik.handleChange}
                                        maxLength={10}
                                    />


                                    <div className="row d-flex justify-content-end mt-2">
                                        <div className="col-md-6 d-flex justify-content-end">
                                            <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                {
                                                    disableSubmit ?
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> Saving...
                                                        </>
                                                        :
                                                        "Update"
                                                }
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </form>
                        </Offcanvas.Body>
                    </Offcanvas>
            }

        </>
    )
}

export default EditCountry